/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';

type TextInputProps = {
	onChange: (value: string) => void;
	wrapperStyle?: React.CSSProperties;
	labelStyle?: React.CSSProperties;
	defaultValue?: string;
	bootstrap?: boolean;
	label?: string;
	required?: boolean;
	style?: React.CSSProperties;
	placeholder?: string;
};

const TextInput = ({
	onChange,
	wrapperStyle = {},
	labelStyle = {},
	defaultValue = '',
	bootstrap = false,
	label = '',
	required = false,
	...props
}: TextInputProps) => {
	const [value, setValue] = useState<string | null>(defaultValue || null);

	function valueChanged(newValue: string) {
		setValue(newValue);
		onChange && onChange(newValue);
	}

	const filteredProps = { ...props };

	['wrapperStyle', 'labelStyle', 'defaultValue']
		.forEach((key) => delete filteredProps[key]);
		
	return (

		<div style={{ position: 'relative', ...wrapperStyle }}>

			{
				label

					? (
						<>
							<label htmlFor={label} style={labelStyle}>
								{label}
							</label>
							<br />
						</>
					)
					: null
			}

			<input
				className={bootstrap ? "form-control" : undefined}
				type="text"
				name={label}
				{...filteredProps}
				value={value || ''}
				onChange={(e) => valueChanged(e.target.value)}
			/>
			
			{
				required !== undefined

					? (
						<span
							style={{
								display: 'inline-block', position: 'absolute', color: 'red', top: '2px', right: '0'
							}}
						>
							*
						</span>
					)
					: null
			}
		</div>
	);
};

export default TextInput;
